module.exports = "<wor-table\n  [(data)]=\"lookups\"\n  [settings]=\"tableSettings\"\n  (query)=\"get($event.params)\">\n</wor-table>\n";